import { StanModal } from '@/components';
import PartyPopper from '@/assets/images/party-popper.svg';
import { createIconElement } from '@/lib';

interface SendOptInEmailSuccessModalProps {
    isOpen: boolean;
    emailsSent: number;
    onClose: () => void;
}

/**
 * Success modal shown after sending opt-in emails
 * Displays the number of emails sent
 */
export const SendOptInEmailSuccessModal = ({ isOpen, emailsSent, onClose }: SendOptInEmailSuccessModalProps) => {
    const recipientText = emailsSent === 1 ? 'contact' : 'contacts';

    return (
        <StanModal
            id='send-opt-in-email-success-modal'
            isOpen={isOpen}
            onClose={onClose}
            size='xs'
            primaryActionLabel='Okay!'
            onPrimaryAction={onClose}
        >
            <div className='flex flex-col items-center justify-center pt-4'>
                {createIconElement(PartyPopper, {
                    className: 'mb-4 size-12',
                    removeFill: false,
                })}

                <>
                    <p className='text-heading-h4 text-dark mb-2 text-center'>
                        Sent to {emailsSent} {recipientText}
                    </p>

                    <p className='text-caption-1-regular text-gray text-center'>
                        Your audience will start receiving emails from you as soon as they opt-in.
                    </p>
                </>
            </div>
        </StanModal>
    );
};
